import { render } from "./SearchResults.vue?vue&type=template&id=6198c20f&ts=true"
import script from "./SearchResults.vue?vue&type=script&lang=ts"
export * from "./SearchResults.vue?vue&type=script&lang=ts"

import "./SearchResults.vue?vue&type=style&index=0&id=6198c20f&lang=css"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__